/* GTJ card extras: wishlist (localStorage), quick add to cart, swatch image swap, header saved-items panel, product page extras */
if (!window.__gtjCardExtras) {
  window.__gtjCardExtras = true;

  var GTJ_WL_KEY = 'gtj-wishlist';
  /* ===== r52 LCP PRIORITISER (perf round, 9Aug) =====
     Every hero slide ships loading="lazy" and no fetchpriority, so the
     LCP image is discovered late and fetched at low priority.
     Why this is done here and NOT server-side in slideshow.liquid:
     the homepage carries TWO slideshow sections (one per breakpoint)
     and BOTH are in the DOM - the inactive one is display:none. A
     server-side loading:'eager' on the first slide would eagerly pull
     the hidden breakpoint's hero too (~300-440KB wasted every visit),
     because display:none does not stop an eager fetch. Only the client
     can tell which one is actually visible. Runs on the first VISIBLE
     hero/product image and stops - purely a loading hint, no markup or
     styling is altered. */
  function gtjPrioritiseLcp() {
    try {
      var cands = document.querySelectorAll(
        '.slideshow__media img, .banner__media img, .product__media-item img, .product__media img'
      );
      for (var i = 0; i < cands.length; i++) {
        var img = cands[i];
        /* offsetParent === null => inside the display:none breakpoint */
        if (img.offsetParent === null && img.getClientRects().length === 0) continue;
        if (img.complete) return; /* already fetched - nothing to gain */
        try { img.fetchPriority = 'high'; } catch (e) {}
        img.setAttribute('fetchpriority', 'high');
        img.loading = 'eager';
        return;
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gtjPrioritiseLcp);
  } else {
    gtjPrioritiseLcp();
  }

  var GTJ_BM_OUTLINE ='<svg class="gtj-bookmark-outline" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h12v16l-6-4.5L1 17V1z" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';
  var GTJ_BM_FILL = '<svg class="gtj-bookmark-fill" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h12v16l-6-4.5L1 17V1z" fill="currentColor"/></svg>';

  function gtjGetWishlist() {
    try { return JSON.parse(localStorage.getItem(GTJ_WL_KEY)) || []; } catch (e) { return []; }
  }
  function gtjSetWishlist(list) {
    try { localStorage.setItem(GTJ_WL_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function gtjMarkSaved(root) {
    var list = gtjGetWishlist();
    (root || document).querySelectorAll('.gtj-bookmark[data-handle]').forEach(function (btn) {
      btn.classList.toggle('is-saved', list.indexOf(btn.getAttribute('data-handle')) !== -1);
    });
    /* 8Aug seamless-cards: overlay bookmarks (cart recs, empty-cart
       recs, search recs) sync too - saving anywhere marks everywhere */
    (root || document).querySelectorAll('.gtj-ctl__bm[data-gtj-ctl-save]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-gtj-ctl-save')) !== -1;
      btn.classList.toggle('is-saved', on);
      var p = btn.querySelector('path');
      if (p) p.setAttribute('fill', on ? 'currentColor' : 'none');
    });
  }

  function gtjCloseAllQuick(except) {
    document.querySelectorAll('.gtj-quick.is-open').forEach(function (q) {
      if (q !== except) q.classList.remove('is-open');
    });
  }

  function gtjSwapCardImage(sw) {
    var url = sw.getAttribute('data-img');
    if (!url) return;
    var card = sw.closest('.card-wrapper');
    if (!card) return;
    var imgs = card.querySelectorAll('.card__media img');
    if (!imgs.length) return;
    imgs[0].removeAttribute('srcset');
    imgs[0].src = url;
    if (imgs[1]) imgs[1].style.display = 'none';
    card.querySelectorAll('.gtj-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
  }

  function gtjUpdateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (cart.item_count > 0 && !document.querySelector('.cart-count-bubble')) {
          var cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) {
            var bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            cartIcon.appendChild(bubble);
          }
        }
      })
      .catch(function () {});
  }

  /* 8Aug r2 scuffers mobile anatomy: each "You may also like" card gets
     TWO small overlay buttons on the image - a bookmark (top-right,
     saves to the gtj wishlist) and a "+" (bottom-right, quick add).
     "+" adds directly for single-variant products; for sized products
     it opens the product page (scuffers-compact - no pill rows eating
     drawer space). Re-run after every drawer re-render. */
  function gtjEnhanceCtl() {
    document.querySelectorAll('cart-drawer .gtj-ctl__card:not([data-gtj-ctl-done])').forEach(function (card) {
      card.setAttribute('data-gtj-ctl-done', '1');
      var h = card.getAttribute('data-gtj-handle');
      if (!h) return;
      var img = card.querySelector('img');
      if (!img) return;
      var wrap = document.createElement('span');
      wrap.className = 'gtj-ctl__imgwrap';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
      var saved = gtjGetWishlist().indexOf(h) > -1;
      var bm = document.createElement('button');
      bm.type = 'button';
      bm.className = 'gtj-ctl__bm' + (saved ? ' is-saved' : '');
      bm.setAttribute('aria-label', 'Save to wishlist');
      bm.setAttribute('data-gtj-ctl-save', h);
      bm.innerHTML = '<svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h12v16l-6-4.5L1 17V1z" stroke="currentColor" stroke-width="1.2" fill="' + (saved ? 'currentColor' : 'none') + '"/></svg>';
      wrap.appendChild(bm);
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'gtj-ctl__plus';
      plus.setAttribute('aria-label', 'Add to cart');
      plus.textContent = '+';
      wrap.appendChild(plus);
      gtjFetchProduct(h)
        .then(function (p) {
          if (!p) return;
          gtjWireRecQuick(wrap, plus, p);
        })
        .catch(function () { plus.setAttribute('data-url', '/products/' + h); });
    });
    /* search recommended products get the same treatment (their
       overlays are liquid-rendered with a data-url fallback) */
    document.querySelectorAll('.gtj-search-extras .gtj-search-rec:not([data-gtj-rq])').forEach(function (rec) {
      rec.setAttribute('data-gtj-rq', '1');
      var plus = rec.querySelector('.gtj-ctl__plus');
      var wrap = rec.querySelector('.gtj-search-rec__media');
      if (!plus || !wrap) return;
      var m = (rec.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      gtjFetchProduct(m[1])
        .then(function (p) { if (p) gtjWireRecQuick(wrap, plus, p); })
        .catch(function () {});
    });
  }

  /* 9Aug r23: product JSON cached per session - tiles wire instantly on
     revisits instead of racing the network (user: "some show, some
     don't, some delay") */
  function gtjFetchProduct(handle) {
    var key = 'gtjp:' + handle;
    try {
      var c = sessionStorage.getItem(key);
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p) { try { sessionStorage.setItem(key, JSON.stringify(p)); } catch (e) {} }
        return p;
      });
  }

  /* 9Aug QUICK-ADD PARITY (user): rec overlays behave EXACTLY like the
     grid cards - single variant = "Add +" one-tap; multi-option = the
     SAME stepped chip picker (option1 -> option2 -> add), never a
     navigate-away. The picker reuses gtjRenderMultiQuick + the generic
     document click handler (both read .gtj-quick-json). */
  function gtjWireRecQuick(wrap, plus, p) {
    /* the picker is absolutely positioned - the wrap must be its
       containing block */
    try { if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative'; } catch (e) {}
    if (p.variants.length === 1) {
      if (p.variants[0].available) {
        /* r27: plus stays a bare + in the SAME spot as every card
           (user: "Add always showing / plus moved"); hover reveals a
           grid-style strip reading ADD, click adds */
        plus.setAttribute('data-variant-id', p.variants[0].id);
        plus.removeAttribute('data-url');
        if (wrap.querySelector('.gtj-quick--recadd')) return;
        var aq = document.createElement('div');
        aq.className = 'gtj-quick gtj-quick--rec gtj-quick--recadd';
        /* r28: grid strip reads "+ ADD" - the real + is hidden under the
           opaque strip, so draw the glyph inside it */
        var pg = document.createElement('span');
        pg.className = 'gtj-quick__plusglyph';
        pg.textContent = '+';
        aq.appendChild(pg);
        var al = document.createElement('span');
        al.className = 'gtj-quick__label';
        al.textContent = 'ADD';
        aq.appendChild(al);
        aq.setAttribute('data-variant-id', p.variants[0].id);
        wrap.appendChild(aq);
        if (plus.__gtjHoverWait) { plus.__gtjHoverWait = false; aq.classList.add('is-open'); }
      } else {
        plus.setAttribute('data-url', '/products/' + p.handle);
      }
      return;
    }
    /* /products/x.js may return options as strings OR {name,...} objects */
    var data = { names: (p.options || []).map(function (o) { return o && o.name ? o.name : o; }), variants: [] };
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var o = [];
      if (v.option1 != null) o.push(v.option1);
      if (v.option2 != null) o.push(v.option2);
      if (v.option3 != null) o.push(v.option3);
      data.variants.push({ id: v.id, a: !!v.available, o: o });
    }
    var quick = document.createElement('div');
    quick.className = 'gtj-quick gtj-quick--multi gtj-quick--rec';
    var js = document.createElement('script');
    js.type = 'application/json';
    js.className = 'gtj-quick-json';
    js.textContent = JSON.stringify(data);
    quick.appendChild(js);
    /* r29: strip keeps the + visible during hover (it sits under the
       opaque strip otherwise), in the same grey the resting + has */
    var mg = document.createElement('span');
    mg.className = 'gtj-quick__plusglyph';
    mg.textContent = '+';
    quick.appendChild(mg);
    var lbl = document.createElement('span');
    lbl.className = 'gtj-quick__label';
    quick.appendChild(lbl);
    var sizes = document.createElement('div');
    sizes.className = 'gtj-quick__sizes';
    quick.appendChild(sizes);
    wrap.appendChild(quick);
    plus.removeAttribute('data-url');
    /* r23: pointer was already hovering while the data was in flight -
       open the picker the moment it exists (kills the "some delay,
       some show nothing" race) */
    if (plus.__gtjHoverWait) {
      plus.__gtjHoverWait = false;
      quick.classList.add('is-open');
      gtjRenderMultiQuick(quick, []);
    }
  }
  /* r44 (user): saves become ad signals. Fire the standard
     AddToWishlist event to Meta + TikTok on every NEW save (never on
     unsave) with the exact product - Meta gets a mid-funnel intent
     signal to optimize on, "saved but didn't buy" audiences become
     buildable, and catalog ads can re-show the exact saved item.
     Product data comes from the sessionStorage-cached /products/x.js
     fetch, so no extra network cost after first touch; pixels are
     guarded - if a blocker killed them this is a silent no-op. */
  function gtjTrackWishlist(handle) {
    if (!handle) return;
    try {
      gtjFetchProduct(handle).then(function (p) {
        var data = {
          content_type: 'product',
          content_name: p && p.title ? p.title : handle,
          content_ids: p && p.variants && p.variants[0] ? [String(p.variants[0].id)] : [handle],
          value: p && p.price ? p.price / 100 : undefined,
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BDT'
        };
        if (typeof window.fbq === 'function') window.fbq('track', 'AddToWishlist', data);
        if (window.ttq && typeof window.ttq.track === 'function') {
          window.ttq.track('AddToWishlist', {
            content_type: 'product',
            content_id: data.content_ids[0],
            content_name: data.content_name,
            value: data.value,
            currency: data.currency
          });
        }
      }).catch(function () {});
    } catch (e) {}
  }
  /* r47 (user: scroll stutters at the image-banner sections): those
     full-screen banner images are loading="lazy", so the fetch+decode
     lands mid-scroll right as the section enters - that IS the jank.
     Once the page has finished loading and the thread is idle, pull
     them in early with async decode so scrolling meets a ready image.
     Runs after `load`, so LCP/first paint are untouched. */
  function gtjWarmBanners() {
    var warm = function () {
      /* r51: the hidden search panel's recommendation images moved from
         eager to lazy (they cost 4 downloads on every page load). Warm
         them here with the banners so the panel still opens with
         pre-decoded images - the 3Aug anti-jank behaviour, minus the
         critical-path cost. */
      document.querySelectorAll('.banner__media img[loading="lazy"], .image-with-text__media img[loading="lazy"], .gtj-search-rec__media img[loading="lazy"]').forEach(function (img) {
        /* r53 (perf round): this used to warm EVERY banner image on the
           page. The homepage carries two slideshow sections - one per
           breakpoint - and the inactive one is display:none, so warming
           pulled ~1.5-2MB of heroes the visitor can never see. Skip any
           image inside a display:none subtree; the search-panel recs are
           exempt because that panel is *meant* to be warmed while
           hidden (see the 3Aug anti-jank note in header-drawer). */
        var isRec = !!img.closest('.gtj-search-rec__media');
        if (!isRec && img.offsetParent === null && img.getClientRects().length === 0) return;
        img.decoding = 'async';
        img.loading = 'eager';
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 });
    else setTimeout(warm, 1500);
  }
  if (document.readyState === 'complete') gtjWarmBanners();
  else window.addEventListener('load', gtjWarmBanners, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gtjEnhanceCtl);
  else gtjEnhanceCtl();
  document.addEventListener('click', function (e) {
    var bm = e.target.closest('.gtj-ctl__bm');
    if (bm) {
      e.preventDefault();
      e.stopPropagation();
      var handle = bm.getAttribute('data-gtj-ctl-save');
      var list = gtjGetWishlist();
      var idx = list.indexOf(handle);
      if (idx > -1) list.splice(idx, 1); else list.push(handle);
      gtjSetWishlist(list);
      var nowSaved = idx === -1;
      if (nowSaved) gtjTrackWishlist(handle);
      bm.classList.toggle('is-saved', nowSaved);
      var path = bm.querySelector('path');
      if (path) path.setAttribute('fill', nowSaved ? 'currentColor' : 'none');
      gtjMarkSaved();
      return;
    }
    var plus = e.target.closest('.gtj-ctl__plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      var vid = plus.getAttribute('data-variant-id');
      if (vid) { gtjAddVariant(vid, plus); return; }
      /* 9Aug quick-add parity: multi-option = open the stepped chip
         picker in place, exactly like the grid cards */
      var rq = plus.parentElement.querySelector('.gtj-quick');
      if (rq) {
        gtjCloseAllQuick(rq);
        var opening = !rq.classList.contains('is-open');
        rq.classList.toggle('is-open');
        if (opening) gtjRenderMultiQuick(rq, []);
        return;
      }
      if (plus.getAttribute('data-url')) window.location.href = plus.getAttribute('data-url');
      return;
    }
    /* chip taps inside rec pickers live inside an <a> card - stop the
       navigation, the generic multi-quick handler (bubble phase) does
       the option stepping + final add */
    /* r27: the hover ADD strip on single-variant rec tiles sits inside
       the card <a> - clicking it must add, never navigate */
    var recAdd = e.target.closest('.gtj-quick--recadd');
    if (recAdd) { e.preventDefault(); e.stopPropagation();
      gtjAddVariant(recAdd.getAttribute('data-variant-id'), recAdd);
      recAdd.classList.remove('is-open');
      return;
    }
    var recChip = e.target.closest('.gtj-quick--rec button[data-opt-value]');
    if (recChip) { e.preventDefault(); e.stopPropagation();
      var mq = recChip.closest('.gtj-quick');
      var data = gtjMultiData(mq);
      if (!data) return;
      var sel = (mq.__gtjSel || []).concat(recChip.getAttribute('data-opt-value'));
      if (sel.length >= data.names.length) {
        var match = data.variants.filter(function (v) {
          for (var i = 0; i < sel.length; i++) { if (v.o[i] !== sel[i]) return false; }
          return true;
        })[0];
        mq.__gtjSel = [];
        mq.classList.remove('is-open');
        if (match) gtjAddVariant(match.id, recChip);
      } else {
        gtjRenderMultiQuick(mq, sel);
      }
      return;
    }
  }, true);

  function gtjRefreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { gtjUpdateCartCount(); return; }
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var newInner = tmp.querySelector('.drawer__inner');
          var curInner = drawer.querySelector('.drawer__inner');
          if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
          drawer.classList.remove('is-empty');
          gtjEnhanceCtl();
        }
        if (sections['cart-icon-bubble']) {
          var bubbleWrap = document.getElementById('cart-icon-bubble');
          if (bubbleWrap) {
            var tmp2 = document.createElement('div');
            tmp2.innerHTML = sections['cart-icon-bubble'];
            bubbleWrap.innerHTML = tmp2.querySelector('#cart-icon-bubble') ? tmp2.querySelector('#cart-icon-bubble').innerHTML : sections['cart-icon-bubble'];
          }
        }
        if (typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () { gtjUpdateCartCount(); });
  }

  function gtjAddVariant(variantId, btn) {
    var original = btn ? btn.innerHTML : null;
    if (btn) btn.innerHTML = '...';
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) {
          /* r41 (user: "says ace"): the checkmark had been mojibake'd
             into the literal chars a-circumflex + oe + quote, which
             reads as "ace". fromCharCode keeps the source pure ASCII
             so no upload/encoding step can ever mangle it again. */
          btn.innerHTML = String.fromCharCode(10003);
          btn.classList.add('is-added');
        }
        gtjRefreshCartDrawer();
        setTimeout(function () {
          if (btn) {
            btn.innerHTML = original;
            btn.classList.remove('is-added');
          }
          gtjCloseAllQuick();
        }, 1200);
      })
      .catch(function () {
        if (btn) {
          btn.innerHTML = '!';
          setTimeout(function () { btn.innerHTML = original; }, 1600);
        }
      });
  }

  /* ---- Multi-option quick add: stepped chip picker (option 1 -> option 2 -> add) ---- */
  function gtjMultiData(quick) {
    if (quick.__gtjData !== undefined) return quick.__gtjData;
    try {
      quick.__gtjData = JSON.parse(quick.querySelector('.gtj-quick-json').textContent);
    } catch (e) { quick.__gtjData = null; }
    return quick.__gtjData;
  }

  function gtjShortValue(v) {
    return String(v).split('/')[0].trim();
  }

  function gtjRenderMultiQuick(quick, sel) {
    var data = gtjMultiData(quick);
    if (!data || !data.variants) return;
    sel = sel || [];
    quick.__gtjSel = sel;
    var step = sel.length;
    var label = quick.querySelector('.gtj-quick__label');
    if (label) label.textContent = data.names && data.names[step] ? data.names[step] : 'Add';
    var wrap = quick.querySelector('.gtj-quick__sizes');
    if (!wrap) return;
    wrap.innerHTML = '';
    var seen = [];
    data.variants.forEach(function (v) {
      for (var i = 0; i < sel.length; i++) { if (v.o[i] !== sel[i]) return; }
      var val = v.o[step];
      if (val == null || seen.indexOf(val) !== -1) return;
      seen.push(val);
    });
    seen.forEach(function (val) {
      var anyAvail = data.variants.some(function (v) {
        if (!v.a) return false;
        for (var i = 0; i < sel.length; i++) { if (v.o[i] !== sel[i]) return false; }
        return v.o[step] === val;
      });
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-opt-value', val);
      b.title = val;
      b.textContent = gtjShortValue(val);
      if (!anyAvail) b.disabled = true;
      wrap.appendChild(b);
    });
  }

  /* ---- Product page: wrap description in an accordion like Shipping ---- */
  function gtjWrapDescription() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.closest('details') || document.querySelector('.gtj-desc-acc')) return;
    var wrap = document.createElement('div');
    wrap.className = 'product__accordion accordion gtj-desc-acc';
    wrap.innerHTML =
      '<details>' +
      '<summary>' +
      '<div class="summary__title"><h2 class="h4 accordion__title">Product Details</h2></div>' +
      '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z" fill="currentColor"></path></svg>' +
      '</summary>' +
      '<div class="accordion__content rte"></div>' +
      '</details>';
    desc.parentNode.insertBefore(wrap, desc);
    wrap.querySelector('.accordion__content').appendChild(desc);
  }

  /* ---- Product page extras ---- */
  function gtjProductPageExtras() {
    var infoContainer = document.querySelector('.product__info-container');
    if (!infoContainer) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];

    /* Prefetch the rest of the gallery + thumbnails after load so slide swipes
       and thumbnail taps don't each wait on a fresh network download */
    var gtjLazyMedia = document.querySelectorAll('.product__media-list img[loading="lazy"], .thumbnail-list img[loading="lazy"]');
    if (gtjLazyMedia.length) {
      var gtjEagerize = function () {
        gtjLazyMedia.forEach(function (im) { im.loading = 'eager'; });
      };
      if (document.readyState === 'complete') setTimeout(gtjEagerize, 300);
      else window.addEventListener('load', function () { setTimeout(gtjEagerize, 300); });
    }

    /* Mobile: center the thumbnail strip when all tiles fit (equal side space) */
    var thumbList = document.querySelector('.thumbnail-list');
    if (thumbList) {
      var gtjCenterThumbs = function () {
        if (window.innerWidth >= 750) { thumbList.style.justifyContent = ''; return; }
        thumbList.style.justifyContent = (thumbList.scrollWidth <= thumbList.clientWidth + 2) ? 'center' : '';
      };
      gtjCenterThumbs();
      window.addEventListener('resize', gtjCenterThumbs);
      window.addEventListener('load', gtjCenterThumbs);
    }

    /* Tablet/desktop stacked gallery: left thumbnail rail - click scrolls to
       that image, and the thumb of the image in view is outlined */
    var stackedWrap = document.querySelector('.product--stacked .product__media-wrapper');
    if (stackedWrap && !stackedWrap.__gtjRail) {
      stackedWrap.__gtjRail = true;
      stackedWrap.addEventListener('click', function (e) {
        if (window.innerWidth < 750) return;
        var li = e.target.closest('.thumbnail-list__item[data-target]');
        if (!li) return;
        e.preventDefault();
        e.stopPropagation();
        var target = stackedWrap.querySelector('[data-media-id="' + li.getAttribute('data-target') + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        stackedWrap.querySelectorAll('.thumbnail-list .thumbnail').forEach(function (b) { b.removeAttribute('aria-current'); });
        var btn = li.querySelector('.thumbnail');
        if (btn) btn.setAttribute('aria-current', 'true');
      }, true);
      if ('IntersectionObserver' in window) {
        var gtjRailIO = new IntersectionObserver(function (entries) {
          if (window.innerWidth < 750) return;
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var li2 = stackedWrap.querySelector('.thumbnail-list__item[data-target="' + en.target.getAttribute('data-media-id') + '"]');
            if (!li2) return;
            stackedWrap.querySelectorAll('.thumbnail-list .thumbnail').forEach(function (b) { b.removeAttribute('aria-current'); });
            var b2 = li2.querySelector('.thumbnail');
            if (b2) {
              b2.setAttribute('aria-current', 'true');
              if (typeof b2.scrollIntoView === 'function') {
                var rail = stackedWrap.querySelector('.thumbnail-slider');
                if (rail && rail.scrollHeight > rail.clientHeight) b2.scrollIntoView({ block: 'nearest' });
              }
            }
          });
        }, { rootMargin: '-35% 0px -55% 0px' });
        stackedWrap.querySelectorAll('.product__media-item[data-media-id]').forEach(function (m) { gtjRailIO.observe(m); });
      }
    }

    /* Bookmark next to product title */
    var titleWrap = infoContainer.querySelector('.product__title');
    if (titleWrap && handle && !titleWrap.querySelector('.gtj-bookmark')) {
      titleWrap.classList.add('gtj-title-flex');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gtj-bookmark';
      b.setAttribute('data-handle', handle);
      b.setAttribute('aria-label', 'Save to wishlist');
      b.innerHTML = GTJ_BM_OUTLINE + GTJ_BM_FILL;
      titleWrap.appendChild(b);
    }

    /* Locate size + color fieldsets */
    var sizeFs = null;
    var colorFs = null;
    infoContainer.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg) return;
      if (/size|talla/i.test(lg.textContent) && !sizeFs) sizeFs = fs;
      if (/colou?r/i.test(lg.textContent) && !colorFs) colorFs = fs;
    });

    /* Stacked ring-size labels */
    if (sizeFs && !sizeFs.classList.contains('gtj-size-compact')) {
      var didCompact = false;
      sizeFs.querySelectorAll('label').forEach(function (lb) {
        var nodes = Array.prototype.slice.call(lb.childNodes);
        nodes.forEach(function (n) {
          if (n.nodeType === 3) {
            var m = n.textContent.match(/US\s*([\d.]+)\s*\/\s*BD\s*([\d.]+)/i);
            if (m) {
              lb.setAttribute('title', 'US ' + m[1] + ' / BD ' + m[2]);
              var s1 = document.createElement('span');
              s1.className = 'gtj-sz-us';
              s1.textContent = 'US ' + m[1];
              var s2 = document.createElement('span');
              s2.className = 'gtj-sz-bd';
              s2.textContent = 'BD ' + m[2];
              lb.insertBefore(s1, n);
              lb.insertBefore(s2, n);
              lb.removeChild(n);
              didCompact = true;
            }
          }
        });
      });
      if (didCompact) sizeFs.classList.add('gtj-size-compact');
    }

    /* Move Size Guide (link OR popup button) into the size legend row */
    var existingSg = infoContainer.querySelector('.gtj-size-guide-link');
    if (existingSg && existingSg.offsetWidth === 0) {
      var deadWrap = existingSg.closest('modal-opener') || existingSg;
      deadWrap.remove();
      existingSg = null;
    }
    if (sizeFs && !existingSg) {
      var sgEl = Array.from(infoContainer.querySelectorAll('a, button')).find(function (el) {
        return /^\s*size\s*guide\s*$/i.test(el.textContent) && !el.closest('legend') && el.offsetWidth > 0;
      });
      if (sgEl) {
        var legend = sizeFs.querySelector('legend');
        var mover = sgEl.closest('modal-opener') || sgEl;
        var oldParent = mover.parentElement;
        legend.classList.add('gtj-legend-row');
        sgEl.classList.add('gtj-size-guide-link');
        legend.appendChild(mover);
        if (oldParent && oldParent.textContent.trim() === '' && !oldParent.querySelector('img,svg,input,modal-opener')) {
          oldParent.remove();
        }
      }
    }

    /* Color options show their plain text names (photo tiles removed
       20Jul per user - variant photo crops looked bad on bags) */

    gtjMarkSaved();
  }

  /* ---- Header saved-items (wishlist) panel ---- */
  var GTJ_BM_SVG = '<svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h12v16l-6-4.5L1 17V1z" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';

  function gtjMoney(cents) {
    try { return (cents / 100).toLocaleString() + ' BDT'; } catch (e) { return (cents / 100) + ' BDT'; }
  }

  /* 8Aug EME-STYLE saved panel in a SCUFFERS-STYLE right drawer:
     each saved item shows size pills IN the list (eme "SELECCIONAR
     TALLA"); picking a size reveals ADD TO CART, which adds via the
     existing gtjAddVariant (it refreshes + auto-opens the cart drawer,
     the scuffers behavior); "Remove" per row. One-variant products get
     the ADD button directly. */
  function gtjRenderWlPanel(panel) {
    var handles = gtjGetWishlist().slice(-12).reverse();
    panel.innerHTML =
      '<div class="gtj-wl-head">' +
      '<p class="gtj-wl-panel__title">Saved' + (handles.length ? ' <sup>' + handles.length + '</sup>' : '') + '</p>' +
      '<button type="button" class="gtj-wl-close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M1.5 1.5L13.5 13.5M13.5 1.5L1.5 13.5" stroke="currentColor" stroke-width="1.2"/></svg>' +
      '</button></div><div class="gtj-wl-body"></div>';
    var body = panel.querySelector('.gtj-wl-body');
    if (!handles.length) {
      body.innerHTML = '<p class="gtj-wl-panel__empty">Nothing saved yet. Tap the bookmark on any product.</p>';
      return;
    }
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var row = document.createElement('div');
          row.className = 'gtj-wl-row';
          var imgSrc = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
          var priceHtml = '';
          if (p.compare_at_price && p.compare_at_price > p.price) {
            priceHtml = '<s class="gtj-wl-item__was">' + gtjMoney(p.compare_at_price) + '</s> ' + gtjMoney(p.price);
          } else {
            priceHtml = gtjMoney(p.price);
          }
          var actions = '';
          if (p.variants.length === 1) {
            actions = '<button type="button" class="gtj-wl-add" data-wl-add="' + p.variants[0].id + '"' +
              (p.variants[0].available ? '' : ' disabled') + '>' +
              (p.variants[0].available ? 'Add to cart' : 'Sold out') + '</button>';
          } else {
            /* 8Aug consistency round: pills render in the PRODUCT PAGE
               language - "US 6 / BD 12" titles become stacked US/BD
               labels (gtj-sz-us / gtj-sz-bd, same classes the PDP
               chips use); other titles (S/M/L etc) stay one line. */
            var pills = p.variants.map(function (v) {
              var m = String(v.title).match(/US\s*([\d.]+)\s*\/\s*BD\s*([\d.]+)/i);
              var label = m
                ? '<span class="gtj-sz-us">US ' + m[1] + '</span><span class="gtj-sz-bd">BD ' + m[2] + '</span>'
                : v.title;
              return '<button type="button" class="gtj-wl-size' + (m ? ' gtj-wl-size--stacked' : '') + '" data-wl-variant="' + v.id + '" title="' + v.title + '"' +
                (v.available ? '' : ' disabled') + '>' + label + '</button>';
            }).join('');
            actions = '<p class="gtj-wl-row__pick">Select size</p>' +
              '<div class="gtj-wl-sizes">' + pills + '</div>' +
              '<button type="button" class="gtj-wl-add" data-wl-add="" hidden>Add to cart</button>';
          }
          row.innerHTML =
            '<div class="gtj-wl-row__main">' +
            '<a class="gtj-wl-item" href="/products/' + p.handle + '">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="">' : '') +
            '<span class="gtj-wl-item__info"><span class="gtj-wl-item__name">' + p.title + '</span>' +
            '<span class="gtj-wl-item__price">' + priceHtml + '</span></span></a>' +
            '<button type="button" class="gtj-wl-item__remove" data-remove-handle="' + p.handle + '">Remove</button>' +
            '</div>' +
            '<div class="gtj-wl-row__actions">' + actions + '</div>';
          body.appendChild(row);
        })
        .catch(function () {});
    });
  }

  function gtjWlShow(panel) {
    gtjRenderWlPanel(panel);
    panel.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    });
  }

  function gtjWlHide(panel) {
    panel.classList.remove('is-open');
    setTimeout(function () { panel.hidden = true; }, 520);
  }

  function gtjInitHeaderWishlist() {
    if (document.querySelector('.gtj-header-bm')) return;
    var icons = document.querySelector('header .header__icons') || document.querySelector('.header__icons');
    if (!icons) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gtj-header-bm';
    btn.setAttribute('aria-label', 'Saved items');
    btn.innerHTML = GTJ_BM_SVG;
    icons.insertBefore(btn, icons.firstChild);
    var panel = document.createElement('div');
    panel.className = 'gtj-wl-panel';
    panel.hidden = true;
    document.body.appendChild(panel);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) gtjWlShow(panel);
      else gtjWlHide(panel);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !e.target.closest('.gtj-wl-panel') && !e.target.closest('.gtj-header-bm')) {
        gtjWlHide(panel);
      }
    });
    panel.addEventListener('click', function (e) {
      var close = e.target.closest('.gtj-wl-close');
      if (close) { gtjWlHide(panel); return; }
      var size = e.target.closest('.gtj-wl-size');
      if (size && !size.disabled) {
        var srow = size.closest('.gtj-wl-row');
        srow.querySelectorAll('.gtj-wl-size').forEach(function (b) { b.classList.remove('is-active'); });
        size.classList.add('is-active');
        var sAdd = srow.querySelector('.gtj-wl-add');
        if (sAdd) {
          sAdd.setAttribute('data-wl-add', size.getAttribute('data-wl-variant'));
          sAdd.hidden = false;
        }
        return;
      }
      var add = e.target.closest('.gtj-wl-add');
      if (add && add.getAttribute('data-wl-add') && !add.disabled) {
        e.preventDefault();
        gtjAddVariant(add.getAttribute('data-wl-add'), add);
        /* gtjAddVariant refreshes + auto-opens the CART drawer (the
           scuffers behavior) - slide the saved panel away under it */
        setTimeout(function () { gtjWlHide(panel); }, 500);
        return;
      }
      var rm = e.target.closest('[data-remove-handle]');
      if (!rm) return;
      e.preventDefault();
      var list = gtjGetWishlist();
      var i = list.indexOf(rm.getAttribute('data-remove-handle'));
      if (i > -1) list.splice(i, 1);
      gtjSetWishlist(list);
      gtjMarkSaved();
      gtjRenderWlPanel(panel);
    });
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('.gtj-plus');
    if (plus) {
      e.preventDefault();
      var directVariant = plus.getAttribute('data-variant-id');
      if (directVariant) {
        gtjAddVariant(directVariant, plus);
        return;
      }
      var href = plus.getAttribute('data-url');
      var quick = plus.parentElement.querySelector('.gtj-quick');
      if (quick) {
        gtjCloseAllQuick(quick);
        var opening = !quick.classList.contains('is-open');
        quick.classList.toggle('is-open');
        if (opening && quick.classList.contains('gtj-quick--multi')) {
          gtjRenderMultiQuick(quick, []);
        }
      } else if (href) {
        window.location.href = href;
      }
      return;
    }

    /* Multi-option quick add: chip picks an option value, last pick adds */
    var optBtn = e.target.closest('.gtj-quick--multi button[data-opt-value]');
    if (optBtn && !optBtn.disabled) {
      e.preventDefault();
      var mq = optBtn.closest('.gtj-quick');
      var data = gtjMultiData(mq);
      if (!data) return;
      var sel = (mq.__gtjSel || []).concat(optBtn.getAttribute('data-opt-value'));
      if (sel.length >= data.names.length) {
        var match = data.variants.filter(function (v) {
          for (var i = 0; i < sel.length; i++) { if (v.o[i] !== sel[i]) return false; }
          return true;
        })[0];
        mq.__gtjSel = [];
        if (match) gtjAddVariant(match.id, optBtn);
      } else {
        gtjRenderMultiQuick(mq, sel);
      }
      return;
    }

    var sw = e.target.closest('.gtj-swatch[data-img]');
    if (sw) {
      e.preventDefault();
      gtjSwapCardImage(sw);
      return;
    }

    var bm = e.target.closest('.gtj-bookmark');
    if (bm) {
      e.preventDefault();
      var handle = bm.getAttribute('data-handle');
      var list = gtjGetWishlist();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); gtjTrackWishlist(handle); } else { list.splice(i, 1); }
      gtjSetWishlist(list);
      gtjMarkSaved();
      return;
    }

    var addBtn = e.target.closest('.gtj-quick button[data-variant-id]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      gtjAddVariant(addBtn.getAttribute('data-variant-id'), addBtn);
      return;
    }

    /* Click anywhere else: close open quick bars */
    if (!e.target.closest('.gtj-quick')) {
      gtjCloseAllQuick();
    }
  });

  /* Hover on a color swatch (desktop): swap the card image */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.gtj-swatch[data-img]');
    if (sw) gtjSwapCardImage(sw);
  });

  function gtjInitMultiQuicks() {
    document.querySelectorAll('.gtj-quick--multi').forEach(function (q) {
      if (!q.querySelector('.gtj-quick__sizes button')) gtjRenderMultiQuick(q, []);
    });
  }

  /* 9Aug r22: RECENTLY VIEWED tiles get full grid parity too - their
     JS-rendered tiles carry a stale stored-data picker (no option
     steps, bare +). Re-wire each tile from /products/x.js: single
     variant = "Add+", multi-option = the stepped picker. Row renders
     async from localStorage -> MutationObserver. */
  function gtjWatchRecent() {
    var row = document.querySelector('.gtj-recent__row');
    if (!row) return;
    var enhance = function () {
      row.querySelectorAll('.gtj-plus:not([data-gtj-rq])').forEach(function (plus) {
        plus.setAttribute('data-gtj-rq', '1');
        var tile = plus.closest('a[href*="/products/"]');
        var href = tile ? tile.getAttribute('href') : '';
        if (!href) {
          var up = plus.parentElement;
          for (var i = 0; i < 4 && up; i++) {
            var a = up.querySelector && up.querySelector('a[href*="/products/"]');
            if (a) { href = a.getAttribute('href'); break; }
            up = up.parentElement;
          }
        }
        var m = String(href || '').match(/\/products\/([^\/?#]+)/);
        if (!m) return;
        var wrap = plus.parentElement;
        gtjFetchProduct(m[1])
          .then(function (p) {
            if (!p) return;
            if (p.variants.length > 1) {
              var old = wrap.querySelector('.gtj-quick');
              if (old) old.parentNode.removeChild(old);
              plus.removeAttribute('data-variant-id');
              plus.removeAttribute('data-url');
            }
            gtjWireRecQuick(wrap, plus, p);
          })
          .catch(function () {});
      });
    };
    enhance();
    if (window.MutationObserver) new MutationObserver(enhance).observe(row, { childList: true, subtree: true });
  }

  /* 9Aug r22: HOVER reveals the picker on devices with a real pointer
     (user: "show colors/materials on hover, then sizes - like mobile's
     tap flow"). Steps follow the product's option order. */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      /* r24 (user): hovering ANYWHERE on the tile reveals the picker -
         grid cards, RV tiles, cart recs, search recs, all the same */
      var zone = e.target.closest('.card__inner, .gtj-recent__media, .gtj-ctl__imgwrap, .gtj-search-rec__media');
      var plus = e.target.closest('.gtj-ctl__plus, .gtj-plus') ||
        (zone ? zone.querySelector('.gtj-plus, .gtj-ctl__plus') : null) ||
        (zone && zone.parentElement ? zone.parentElement.querySelector('.gtj-plus, .gtj-ctl__plus') : null);
      if (!plus) return;
      var q = plus.parentElement.querySelector('.gtj-quick');
      /* r27: singles carry data-variant-id AND an ADD strip - only skip
         when there is genuinely nothing to reveal (grid singles) */
      if (!q && plus.getAttribute('data-variant-id')) return;
      if (q && !q.classList.contains('is-open')) {
        gtjCloseAllQuick(q);
        q.classList.add('is-open');
        if (q.classList.contains('gtj-quick--multi')) gtjRenderMultiQuick(q, []);
      } else if (!q && !plus.getAttribute('data-url')) {
        /* data still in flight - open as soon as it lands */
        plus.__gtjHoverWait = true;
      }
    });
    document.addEventListener('mouseout', function (e) {
      var open = document.querySelector('.gtj-quick.is-open');
      if (!open) return;
      var tile = open.parentElement;
      if (tile.contains(e.target) && !(e.relatedTarget && tile.contains(e.relatedTarget))) {
        open.classList.remove('is-open');
      }
    });
  }

  function gtjInit() {
    gtjMarkSaved();
    gtjInitHeaderWishlist();
    gtjWrapDescription();
    gtjProductPageExtras();
    gtjInitMultiQuicks();
    gtjWatchRecent();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gtjInit);
  } else {
    gtjInit();
  }
  document.addEventListener('shopify:section:load', function () { gtjMarkSaved(); gtjInitMultiQuicks(); });
}
